import { Box, Tooltip } from '@workwhile/ui'
import { WorkSource } from 'typings/common_defs'
import { DayforceIcon } from './DayforceIcon'

export const WorkSourceBadge = ({
  workSource,
}: {
  workSource?: WorkSource
}) => {
  if (workSource === 'dayforce') {
    return (
      <Tooltip content="Shift originated from the Dayforce integration">
        <Box width={12} height={18}>
          <DayforceIcon width={12} />
        </Box>
      </Tooltip>
    )
  }

  return null
}
